// extracted by mini-css-extract-plugin
export default {"setting":"settings_setting__h74r3","passwordChange":"settings_passwordChange__5BXgX","inputs":"settings_inputs__4SnCj"};